export const FOOTER_HEIGHT = 120;